import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";

const IconButtonWithTooltip = ({ tooltip, onClick, children }) => (
  <Tooltip title={tooltip}>
    <button
      onClick={onClick}
      className="p-2 hover:bg-gray-100 hover:text-sss-info text-gray-700 active:bg-cyan-100 transition duration-100"
    >
      {children}
    </button>
  </Tooltip>
);

IconButtonWithTooltip.propTypes = {
  tooltip: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default IconButtonWithTooltip;
